module.exports = __webpack_public_path__ + "static/media/edit.d9c89d27.svg";